import { memo, useMemo } from "react";

import PdfDocumentHtmlSimple from "./pdf-document-html-simple.component";
import PdfDocumentHtmlWithTableAdjustments from "./pdf-document-html-with-table-adjustments.component";

type PdfDocumentHtmlProps = {
  bodyHtml?: string | null;
  pdfNativeTablesEnabled?: boolean;
};

function PdfDocumentHtml({
  bodyHtml,
  pdfNativeTablesEnabled
}: PdfDocumentHtmlProps) {
  // Optimize table detection by caching the result
  const shouldUseTableAdjustments = useMemo(() => {
    return pdfNativeTablesEnabled && bodyHtml && bodyHtml.includes("<table");
  }, [pdfNativeTablesEnabled, bodyHtml]);

  if (shouldUseTableAdjustments) {
    return <PdfDocumentHtmlWithTableAdjustments bodyHtml={bodyHtml} />;
  } else {
    return <PdfDocumentHtmlSimple bodyHtml={bodyHtml} />;
  }
}

// Memoize component to prevent unnecessary re-renders
export default memo(PdfDocumentHtml);
